"use client";
import { useAppSelector } from "@/data/redux/store";
import { isHalloweenDate } from "@/styles/holiday";
import { halloweenTheme, theme } from "@/styles/Theme";
import { ThemeProvider } from "@mui/material/styles";

// Picks the seasonal theme live from redux so toggling holiday mode re-themes without a reload.
export default function AppTheme({ children }: { children: React.ReactNode }) {
  const holidayMode = useAppSelector((state) => state.app.holidayMode);
  const active = (holidayMode ?? true) && isHalloweenDate(new Date());

  return (
    <ThemeProvider theme={active ? halloweenTheme : theme} defaultMode="system">
      {children}
    </ThemeProvider>
  );
}
